import { ReactNode } from 'react'

// Side is not an exported type from Radix. So we have to define it here.
// This enum is based on what I see in the source code for radix popper: export const SIDE_OPTIONS: readonly ["top", "right", "bottom", "left"];
export enum Side {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
}

export interface TooltipProps {
  className?: string
  content: ReactNode
  children: ReactNode
  testId?: string
  /**
   * Controlled open state. When provided, the consumer owns the open/closed
   * state and Radix delegates ALL transitions (hover, focus, tap, escape)
   * through `onOpenChange`. Leave undefined for the standard Radix-managed
   * (hover/focus only) behavior.
   */
  open?: boolean
  onOpenChange?: (open: boolean) => void
  addButtonWrapper?: boolean
  triggerClassName?: string
  side?: Side
}
